import React from 'react';
import Scrollchor from 'react-scrollchor';

export default (props) => {
    const to = `#${props.link}`;
    return (

        <li className="navbar__menu-item" onClick={props.closeMenu}>
            <Scrollchor to={to} animate={{ duration: 800 }} className="navbar__menu-item-link">
                {props.item}
            </Scrollchor>
        </li>
    )
}

//<a href={to} className="navbar__menu-item-link" onClick={props.closeMenu}>{props.item}</a>


// WEBPACK FOOTER //
// ./src/components/NavbarItem.js